(function () {
  'use strict';

  // ============================================================
  // KEUZEHULP PETTERNS — Aanbevelingsmodule
  // ============================================================
  // Beschrijving : 4-staps drawer die bezoekers helpt het juiste
  //               akoestische kunstwerk te kiezen op basis van
  //               muurkleur, kleurstrategie, formaat en stijl.
  //
  // Werking      :
  //   Stap 1 (muurkleur) × Stap 2 (blend/statement)
  //     → bepaalt de 6 aanbevolen kleuren via KLEUR_MATRIX
  //   Stap 3 (formaat) + Stap 4 (stijl, multi-select)
  //     → selecteert max. 3 designs via round-robin uit DESIGNS
  //
  // Aanpassen    :
  //   Kleur toevoegen      → voeg entry toe aan KLEUREN
  //   Kleuradvies wijzigen → pas arrays in KLEUR_MATRIX aan
  //   Design toevoegen     → voeg object toe aan DESIGNS[formaat]
  //   Pagina-detectie      → pas isAkoestischPagina() aan
  //   Afmetingen           → pas AFMETINGEN en FORMATEN aan
  //
  // Afhankelijkheden : geen (vanilla JS, ES5-compatible)
  // ============================================================


  // ============================================================
  // DATA — Muurkleuren (stap 1)
  // ============================================================
  // 8 kleurcategorieën die de meest voorkomende wandkleuren dekken.
  // hex wordt gebruikt voor:
  //   • de kleurpil in stap 1
  //   • de muurpreview in stap 2
  //   • isDark()-check voor statement-contrast

  var MUURKLEUREN = [
    { id: 'wit-lichtgrijs', naam: 'Wit & lichtgrijs', hex: '#EFEFEC' },
    { id: 'warm-neutraal',  naam: 'Warm neutraal',    hex: '#D2B490' },
    { id: 'warm-donker',    naam: 'Warm donker',      hex: '#B8603A' },
    { id: 'koel-neutraal',  naam: 'Koel neutraal',    hex: '#9DADB2' },
    { id: 'koel-donker',    naam: 'Koel donker',      hex: '#4A5260' },
    { id: 'groen',          naam: 'Groen',             hex: '#788E65' },
    { id: 'blauw-petrol',   naam: 'Blauw & petrol',   hex: '#38677A' },
    { id: 'zwart-donker',   naam: 'Zwart & donker',   hex: '#282828' }
  ];


  // ============================================================
  // DATA — Kleurenpalet (50 kleuren)
  // ============================================================
  // Volledig viltkleurenpalet van Petterns.
  // Sleutel = Kleurcode uit pet_vilt_kleuren.csv
  //
  // img  : echte staalfoto op Shopify CDN (400×400px)
  //        bestandsnaam = kh-swatch-{code}.jpg
  // hex  : fallback kleur als de afbeelding niet laadt
  //
  // Niet alle kleuren staan in KLEUR_MATRIX; ongebruikte codes
  // zijn beschikbaar als je de matrix later wilt uitbreiden.

  var CDN       = 'https://cdn.shopify.com/s/files/1/0835/2838/4847/t/5/assets/';
  var CDN_KLEUR = 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/';

  // gpoWaarde : exacte waarde voor properties['Maatwerk kleur'] (GPO app op de PDP).
  //             null voor de 2 standaard Shopify-varianten (Zand / Gebroken wit).
  // variantKleur : naam van de Shopify kleurvariant die als basis dient bij het
  //               toevoegen aan de winkelmand. Standaard 'Zand'; overschreven voor
  //               Zand (435_NL) en Gebroken wit (32).

  var KLEUREN = {
    '01':     { naam: 'Dark Blue',    hex: '#1B2D5C', img: CDN + 'kh-swatch-01.jpg',     gpoWaarde: 'Dark Blue (01)',       variantKleur: 'Zand' },
    '03':     { naam: 'Antraciet',    hex: '#4A4A4A', img: CDN + 'kh-swatch-03.jpg',     gpoWaarde: 'Antraciet (03)',       variantKleur: 'Zand' },
    '05':     { naam: 'Yellow',       hex: '#F4CE3A', img: CDN + 'kh-swatch-05.jpg',     gpoWaarde: 'Yellow (05)',          variantKleur: 'Zand' },
    '06':     { naam: 'Vanille',      hex: '#F4E8CC', img: CDN + 'kh-swatch-06.jpg',     gpoWaarde: 'Vanille (06)',         variantKleur: 'Zand' },
    '09':     { naam: 'Black',        hex: '#1A1A1A', img: CDN + 'kh-swatch-09.jpg',     gpoWaarde: 'Black (09)',           variantKleur: 'Zand' },
    '12':     { naam: 'Silver Grey',  hex: '#BEBEBC', img: CDN + 'kh-swatch-12.jpg',     gpoWaarde: 'Silver Grey (12)',     variantKleur: 'Zand' },
    '13':     { naam: 'Terra',        hex: '#C4643C', img: CDN + 'kh-swatch-13.jpg',     gpoWaarde: 'Terra (13)',           variantKleur: 'Zand' },
    '14':     { naam: 'Light Blue',   hex: '#88B6D2', img: CDN + 'kh-swatch-14.jpg',     gpoWaarde: 'Light Blue (14)',      variantKleur: 'Zand' },
    '16':     { naam: 'Grey',         hex: '#8C8C8C', img: CDN + 'kh-swatch-16.jpg',     gpoWaarde: 'Grey (16)',            variantKleur: 'Zand' },
    '17':     { naam: 'Blush',        hex: '#E6B0A4', img: CDN + 'kh-swatch-17.jpg',     gpoWaarde: 'Blush (17)',           variantKleur: 'Zand' },
    '19':     { naam: 'Green',        hex: '#588A3A', img: CDN + 'kh-swatch-19.jpg',     gpoWaarde: 'Green (19)',           variantKleur: 'Zand' },
    '20':     { naam: 'White',        hex: '#F0F0EE', img: CDN + 'kh-swatch-20.jpg',     gpoWaarde: 'White (20)',           variantKleur: 'Zand' },
    '22':     { naam: 'Dark Camel',   hex: '#9E763E', img: CDN + 'kh-swatch-22.jpg',     gpoWaarde: 'Dark Camel (22)',      variantKleur: 'Zand' },
    '23':     { naam: 'Dark Grey',    hex: '#545454', img: CDN + 'kh-swatch-23.jpg',     gpoWaarde: 'Dark Grey (23)',       variantKleur: 'Zand' },
    '24':     { naam: 'Cherry',       hex: '#9A1A4A', img: CDN + 'kh-swatch-24.jpg',     gpoWaarde: 'Cherry (24)',          variantKleur: 'Zand' },
    '25':     { naam: 'Red',          hex: '#CA2626', img: CDN + 'kh-swatch-25.jpg',     gpoWaarde: 'Red (25)',             variantKleur: 'Zand' },
    '26':     { naam: 'Dark Green',   hex: '#285230', img: CDN + 'kh-swatch-26.jpg',     gpoWaarde: 'Dark Green (26)',      variantKleur: 'Zand' },
    '27':     { naam: 'Middle Blue',  hex: '#4676B2', img: CDN + 'kh-swatch-27.jpg',     gpoWaarde: 'Middle Blue (27)',     variantKleur: 'Zand' },
    '32':     { naam: 'Off White',    hex: '#E6DECE', img: CDN + 'kh-swatch-32.jpg',     gpoWaarde: null,                   variantKleur: 'Gebroken wit' },
    '38':     { naam: 'Midnight Blue',hex: '#1A2848', img: CDN + 'kh-swatch-38.jpg',     gpoWaarde: 'Midnight Blue (38)',   variantKleur: 'Zand' },
    '39':     { naam: 'Light Oak',    hex: '#D2A66E', img: CDN + 'kh-swatch-39.jpg',     gpoWaarde: 'Light Oak (39)',       variantKleur: 'Zand' },
    '40':     { naam: 'Cool Grey',    hex: '#98A9B6', img: CDN + 'kh-swatch-40.jpg',     gpoWaarde: 'Cool Grey (40)',       variantKleur: 'Zand' },
    '41':     { naam: 'Purple',       hex: '#763E9E', img: CDN + 'kh-swatch-41.jpg',     gpoWaarde: 'Purple (41)',          variantKleur: 'Zand' },
    '43':     { naam: 'Lime',         hex: '#8AC61E', img: CDN + 'kh-swatch-43.jpg',     gpoWaarde: 'Lime (43)',            variantKleur: 'Zand' },
    '48':     { naam: 'Olive',        hex: '#767E3E', img: CDN + 'kh-swatch-48.jpg',     gpoWaarde: 'Olive (48)',           variantKleur: 'Zand' },
    '51':     { naam: 'Apple Green',  hex: '#6AB61E', img: CDN + 'kh-swatch-51.jpg',     gpoWaarde: 'Apple Green (51)',     variantKleur: 'Zand' },
    '53':     { naam: 'Brown',        hex: '#6E3E2E', img: CDN + 'kh-swatch-53.jpg',     gpoWaarde: 'Brown (53)',           variantKleur: 'Zand' },
    '56':     { naam: 'Orange',       hex: '#DE661E', img: CDN + 'kh-swatch-56.jpg',     gpoWaarde: 'Orange (56)',          variantKleur: 'Zand' },
    '57':     { naam: 'Petrol',       hex: '#286876', img: CDN + 'kh-swatch-57.jpg',     gpoWaarde: 'Petrol (57)',          variantKleur: 'Zand' },
    '58':     { naam: 'Light Camel',  hex: '#D2AE7E', img: CDN + 'kh-swatch-58.jpg',     gpoWaarde: 'Light Camel (58)',     variantKleur: 'Zand' },
    '65':     { naam: 'Copper',       hex: '#BE763E', img: CDN + 'kh-swatch-65.jpg',     gpoWaarde: 'Copper (65)',          variantKleur: 'Zand' },
    '83':     { naam: 'Gold',         hex: '#D2A63E', img: CDN + 'kh-swatch-83.jpg',     gpoWaarde: 'Gold (83)',            variantKleur: 'Zand' },
    '88':     { naam: 'Snow',         hex: '#F6F2EE', img: CDN + 'kh-swatch-88.jpg',     gpoWaarde: 'Snow (88)',            variantKleur: 'Zand' },
    '105_NL': { naam: 'Antraciet',    hex: '#464646', img: CDN + 'kh-swatch-105_NL.jpg', gpoWaarde: 'Antraciet (105_NL)',   variantKleur: 'Zand' },
    '108_NL': { naam: 'Zwart',        hex: '#1C1C1C', img: CDN + 'kh-swatch-108_NL.jpg', gpoWaarde: 'Zwart (108_NL)',       variantKleur: 'Zand' },
    '124_NL': { naam: 'Madelief Wit', hex: '#EEEAE2', img: CDN + 'kh-swatch-124_NL.jpg', gpoWaarde: 'Madelief wit (124_NL)',variantKleur: 'Zand' },
    '133_NL': { naam: 'Beton Grijs',  hex: '#A6A6A2', img: CDN + 'kh-swatch-133_NL.jpg', gpoWaarde: 'Beton Grijs (133_NL)', variantKleur: 'Zand' },
    '146_NL': { naam: 'Marmer',       hex: '#D2CEC6', img: CDN + 'kh-swatch-146_NL.jpg', gpoWaarde: 'Marmer (146_NL)',      variantKleur: 'Zand' },
    '280_NL': { naam: 'Staal Blauw',  hex: '#667E9E', img: CDN + 'kh-swatch-280_NL.jpg', gpoWaarde: 'Staal Blauw (280_NL)', variantKleur: 'Zand' },
    '284_NL': { naam: 'Marine Blauw', hex: '#283E66', img: CDN + 'kh-swatch-284_NL.jpg', gpoWaarde: 'Marine Blauw (284_NL)',variantKleur: 'Zand' },
    '368_NL': { naam: 'Smaragd',      hex: '#18664E', img: CDN + 'kh-swatch-368_NL.jpg', gpoWaarde: 'Smaragd (368_NL)',     variantKleur: 'Zand' },
    '372_NL': { naam: 'Eucalyptus',   hex: '#689676', img: CDN + 'kh-swatch-372_NL.jpg', gpoWaarde: 'Eucalyptus (372_NL)', variantKleur: 'Zand' },
    '388_NL': { naam: 'Zeegroen',     hex: '#388676', img: CDN + 'kh-swatch-388_NL.jpg', gpoWaarde: 'Zeegroen (388_NL)',    variantKleur: 'Zand' },
    '421_NL': { naam: 'Muskaat',      hex: '#967656', img: CDN + 'kh-swatch-421_NL.jpg', gpoWaarde: 'Muskaat (421_NL)',     variantKleur: 'Zand' },
    '435_NL': { naam: 'Zand',         hex: '#D2B68E', img: CDN + 'kh-swatch-435_NL.jpg', gpoWaarde: null,                   variantKleur: 'Zand' },
    '463_NL': { naam: 'Turf',         hex: '#6A4E3E', img: CDN + 'kh-swatch-463_NL.jpg', gpoWaarde: 'Turf (463_NL)',        variantKleur: 'Zand' },
    '482_NL': { naam: 'Bastard',      hex: '#26261E', img: CDN + 'kh-swatch-482_NL.jpg', gpoWaarde: 'Bastard (482_NL)',     variantKleur: 'Zand' },
    '546_NL': { naam: 'Koraal Rood',  hex: '#D24640', img: CDN + 'kh-swatch-546_NL.jpg', gpoWaarde: 'Koraal Rood (546_NL)', variantKleur: 'Zand' },
    '553_NL': { naam: 'Mosterd',      hex: '#C69226', img: CDN + 'kh-swatch-553_NL.jpg', gpoWaarde: 'Mosterd (553_NL)',     variantKleur: 'Zand' },
    '582_NL': { naam: 'Pompoen',      hex: '#D25A1E', img: CDN + 'kh-swatch-582_NL.jpg', gpoWaarde: 'Pompoen (582_NL)',     variantKleur: 'Zand' }
  };


  // ============================================================
  // DATA — Types (Inliggend / Opliggend / Twin)
  // ============================================================
  // waarde moet exact overeenkomen met Shopify variant option3.

  var TYPES = [
    { waarde: 'Inliggend',                              naam: 'Inliggend' },
    { waarde: 'Opliggend',                              naam: 'Opliggend' },
    { waarde: 'Twin (Set inliggend \u00e9n opliggend)', naam: 'Twin', sub: '(Set inliggend en opliggend)' }
  ];


  // ============================================================
  // DATA — Kleur matrix (muurkleur × blend/statement → kleuren)
  // ============================================================
  // Per muurkleur-categorie twee arrays van 6 kleurcodes:
  //   blend     = ton-sur-ton, harmoniseert met de muur
  //   statement = contrasteert met de muur, valt op
  //
  // Codes verwijzen naar sleutels in KLEUREN hierboven.
  // De eerste 6 codes worden getoond als grote swatches op de
  // resultaatpagina.

  var KLEUR_MATRIX = {
    'wit-lichtgrijs': {
      blend:     ['20', '88', '32', '124_NL', '12', '40'],
      statement: ['09', '108_NL', '03', '38', '57', '26']
    },
    'warm-neutraal': {
      blend:     ['435_NL', '58', '39', '06', '32', '421_NL'],
      statement: ['57', '38', '284_NL', '368_NL', '26', '01']
    },
    'warm-donker': {
      blend:     ['13', '65', '553_NL', '83', '582_NL', '421_NL'],
      statement: ['14', '280_NL', '40', '20', '88', '12']
    },
    'koel-neutraal': {
      blend:     ['40', '12', '16', '133_NL', '146_NL', '88'],
      statement: ['13', '65', '546_NL', '553_NL', '582_NL', '56']
    },
    'koel-donker': {
      blend:     ['03', '105_NL', '23', '108_NL', '133_NL', '38'],
      statement: ['20', '88', '124_NL', '14', '435_NL', '12']
    },
    'groen': {
      blend:     ['48', '26', '372_NL', '388_NL', '368_NL', '19'],
      statement: ['13', '546_NL', '65', '20', '435_NL', '553_NL']
    },
    'blauw-petrol': {
      blend:     ['57', '01', '38', '27', '284_NL', '280_NL'],
      statement: ['553_NL', '83', '13', '65', '435_NL', '582_NL']
    },
    'zwart-donker': {
      blend:     ['09', '108_NL', '03', '105_NL', '23', '482_NL'],
      statement: ['20', '88', '124_NL', '32', '40', '12']
    }
  };


  // ============================================================
  // DATA — Stijl SVG-illustraties (stap 4 tiles)
  // ============================================================
  // Inline SVG's per stijl-id. Gebruik currentColor zodat ze
  // mee veranderen bij de actieve (groene) tile-stijl.

  var STIJL_SVGS = {
    organisch: '<svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M8,38 C28,22 48,54 68,38 C88,22 108,38 118,32" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round"/><path d="M8,60 C28,44 48,76 68,60 C88,44 108,60 118,54" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round"/><path d="M8,82 C28,66 48,98 68,82 C88,66 108,82 118,76" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round"/></svg>',
    grafisch:  '<svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><rect x="18" y="18" width="38" height="38" stroke="currentColor" stroke-width="2" fill="none"/><rect x="64" y="18" width="38" height="38" stroke="currentColor" stroke-width="2" fill="currentColor"/><rect x="18" y="64" width="38" height="38" stroke="currentColor" stroke-width="2" fill="currentColor"/><rect x="64" y="64" width="38" height="38" stroke="currentColor" stroke-width="2" fill="none"/></svg>',
    speels:    '<svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><circle cx="34" cy="36" r="17" fill="currentColor"/><circle cx="78" cy="28" r="10" fill="currentColor" opacity="0.55"/><circle cx="86" cy="78" r="19" fill="currentColor" opacity="0.8"/><circle cx="38" cy="80" r="12" fill="currentColor" opacity="0.45"/><circle cx="60" cy="56" r="6" fill="currentColor" opacity="0.35"/></svg>',
    klassiek:  '<svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M60,92 A32,32 0 0,1 60,28" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round"/><line x1="60" y1="28" x2="60" y2="92" stroke="currentColor" stroke-width="1.5" opacity="0.35"/><line x1="28" y1="60" x2="92" y2="60" stroke="currentColor" stroke-width="1.5" opacity="0.25"/></svg>'
  };


  // ============================================================
  // DATA — Stijlen (stap 4)
  // ============================================================
  // id moet overeenkomen met het stijl-veld in DESIGNS.

  var STIJLEN = [
    { id: 'organisch', naam: 'Organisch & rustig',  omschrijving: 'Vloeiend, natuurlijk en zacht' },
    { id: 'grafisch',  naam: 'Grafisch & strak',    omschrijving: 'Geometrisch, structuur en lijnen' },
    { id: 'speels',    naam: 'Speels & expressief', omschrijving: 'Beweging, energie en karakter' },
    { id: 'klassiek',  naam: 'Klassiek & tijdloos', omschrijving: 'Subtiel, verfijnd en tijdloos' }
  ];


  // ============================================================
  // DATA — Designs (21 producten, per formaat)
  // ============================================================
  // handle : Shopify product URL handle (voor PDP-deeplink)
  // naam   : weergavenaam op de resultaatkaart
  // stijl  : koppeling met STIJLEN[].id
  // img    : Shopify CDN URL van de productfoto
  //
  // Formaten: vierkant (1:1) · rechthoek (2:3) · panorama (1:2)
  // Per formaat zijn per stijl 1–3 designs beschikbaar;
  // de engine kiest er max. 3 via round-robin.

  var DESIGNS = {
    vierkant: [
      { handle: 'wave',      naam: 'Wave',      stijl: 'organisch', img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/WAVE-1x1_0003.png?v=1748243693' },
      { handle: 'flexible',  naam: 'Flexible',  stijl: 'organisch', img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/FLEXIBLE_1x1_0002_e64b4504-423f-4872-8213-e4f4ecc0f82e.png?v=1748243701' },
      { handle: 'placetobe', naam: 'Placetobe', stijl: 'grafisch',  img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/PLACETOBE_1x1_0003_16ef52ec-5768-4fd6-a74c-6a9af315caa6.png?v=1748243705' },
      { handle: 'spinning',  naam: 'Spinning',  stijl: 'grafisch',  img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/SPINNING_1x1_0002_12ba9ebe-1232-4486-8b2f-6c63d23d93cd.png?v=1748243707' },
      { handle: 'cow',       naam: 'Cow',       stijl: 'speels',    img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/COW_1x1_0003_06696f60-793e-4939-a4e4-f1e4591a1d55.png?v=1748243698' },
      { handle: 'splash',    naam: 'Splash',    stijl: 'speels',    img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/SPLASH_1x1_0003.png?v=1748243709' },
      { handle: 'moonie',    naam: 'Moonie',    stijl: 'klassiek',  img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/MOONIE_1x1_0002_50507be0-023a-4499-a8c5-86a902fef99c.png?v=1748243703' }
    ],
    rechthoek: [
      { handle: 'plants',  naam: 'Plants',  stijl: 'organisch', img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/PLANTS_1x15_0003.png?v=1748243718' },
      { handle: 'leaves',  naam: 'Leaves',  stijl: 'organisch', img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/LEAVES_1x15_0002.png?v=1748243695' },
      { handle: 'organic', naam: 'Organic', stijl: 'organisch', img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/ORGANIC_1x15_0003.png?v=1748243713' },
      { handle: 'party',   naam: 'Party',   stijl: 'grafisch',  img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/PARTY_1x15_0002.png?v=1748243714' },
      { handle: 'people',  naam: 'People',  stijl: 'speels',    img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/PEOPLE_1x15_0003.png?v=1748243716' },
      { handle: 'rainbow', naam: 'Rainbow', stijl: 'speels',    img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/RAINBOW_1x15_0002.png?v=1748243720' },
      { handle: 'liv',     naam: 'Liv',     stijl: 'klassiek',  img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/LIV_1x15_0003_464f3df0-c310-4079-8012-ed3b6b7308a3.png?v=1748243711' }
    ],
    panorama: [
      { handle: 'swirl',      naam: 'Swirl',      stijl: 'organisch', img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/SWIRL-1-20002.png?v=1748243729' },
      { handle: 'steam',      naam: 'Steam',      stijl: 'organisch', img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/STEAM-1-20003.png?v=1748243728' },
      { handle: 'eye',        naam: 'Eye',        stijl: 'grafisch',  img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/EYE-1-20003.png?v=1748243722' },
      { handle: 'zeb',        naam: 'Zeb',        stijl: 'speels',    img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/ZEB-1-20003.png?v=1748243731' },
      { handle: 'lava',       naam: 'Lava',       stijl: 'speels',    img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/LAVA-1-20002.png?v=1748243726' },
      { handle: 'bone',       naam: 'Bone',       stijl: 'klassiek',  img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/BONE-1-20002.png?v=1748243697' },
      { handle: 'hieroglyph', naam: 'Hieroglyph', stijl: 'klassiek',  img: 'https://cdn.shopify.com/s/files/1/0835/2838/4847/files/HIEROGLYPH-1-20002.png?v=1748243724' }
    ]
  };


  // ============================================================
  // DATA — Collectie-handles (voor PDP-links op resultaatpagina)
  // ============================================================
  // Pas aan als de Shopify collectie-URL verandert.

  var COLLECTIES = {
    vierkant:  'akoestische-kunstwerken-vierkant',
    rechthoek: 'akoestische-kunst-rechthoek',
    panorama:  'akoestische-kunst-panorama'
  };

  // Verwijzing naar de kindercollectie op de resultaatpagina.
  // Alleen getoond bij formaat 'rechthoek' — de dieren bestaan enkel in 60×90.
  var KINDER_COLLECTIE = {
    url: '/collections/kindercollectie-akoestische-kunst',
    fotos: [
      CDN_KLEUR + 'rechthoek-toekan-inliggend-43-lime-pet-panel-9.png?v=1780650420&width=200',
      CDN_KLEUR + 'rechthoek-hommel-inliggend-05-yellow-pet-panel-9.png?v=1780649122&width=200',
      CDN_KLEUR + 'rechthoek-krab-inliggend-546_-nl-koraal-rood.png?v=1780646110&width=200'
    ]
  };

  // Mapping van keuzehulp-formaat naar bestandsnaam-slug van de kleurafbeeldingen.
  // Panorama-files gebruiken 'langwerpig' als prefix (afwijkend van de formaat-id).
  var FORMAAT_SLUG = { vierkant: 'vierkant', rechthoek: 'rechthoek', panorama: 'langwerpig' };

  // Zwarte kleuren worden naar het einde van de aanbevolen-lijst geplaatst
  // zodat de eerste aanbevolen kleur nooit een zwart swatch is.
  var ZWART_CODES = ['09', '108_NL', '482_NL'];
  // Designs zonder kleurafbeeldingen — tonen standaard Shopify-foto, geen swatches.
  var GEEN_KLEUR_IMG = [];


  // ============================================================
  // DATA — Afmetingen en formaten
  // ============================================================
  // AFMETINGEN: volgorde = klein → groot, correspondeert 1-op-1
  //             met IMPACT_LABELS (Subtiel → Eyecatcher).
  // FORMATEN:   wordt gebruikt voor de tiles in stap 3.

  var AFMETINGEN = {
    vierkant:  ['40×40 cm', '60×60 cm', '80×80 cm', '120×120 cm'],
    rechthoek: ['40×60 cm', '60×90 cm', '80×120 cm', '120×180 cm'],
    panorama:  ['40×80 cm', '60×120 cm', '80×160 cm', '120×240 cm']
  };

  var FORMATEN = [
    { id: 'vierkant',  naam: 'Vierkant',  verhouding: '1:1', range: '40×40 – 120×120 cm' },
    { id: 'rechthoek', naam: 'Rechthoek', verhouding: '2:3', range: '40×60 – 120×180 cm' },
    { id: 'panorama',  naam: 'Panorama',  verhouding: '1:2', range: '40×80 – 120×240 cm' }
  ];

  // Impact-labels voor de 4 afmetingen op de resultaatpagina.
  var IMPACT_LABELS = ['Subtiel', 'Opvallend', 'Blikvanger', 'Eyecatcher'];


  // ============================================================
  // HELPERS
  // ============================================================

  // maatShopify — '40×40 cm' → '40 x 40 cm' (Shopify variant option2 formaat)
  function maatShopify(m) { return m.replace('\u00d7', ' x '); }

  // formatPrijs — centen (integer) → '€ 29,95'
  // Zonder valutateken, net als de prijzen op de producttegels en de productpagina.
  function formatPrijs(centen) {
    return (centen / 100).toFixed(2).replace('.', ',');
  }

  // imgSrc — Shopify CDN URL + ?width=N voor responsive afbeeldingen
  function imgSrc(url, breedte) {
    if (!url) return '';
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    return url + sep + 'width=' + breedte;
  }

  // escAttr — escapet aanhalingstekens voor gebruik in HTML-attribuutwaarden
  function escAttr(s) { return String(s).replace(/"/g, '&quot;'); }
  function escHtml(s) { return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

  // isDark — true als de perceptuele luminantie van een hex-kleur
  // onder de 150 valt. Gebruikt in stap 2 om de statement-preview
  // aan te passen: donkere muur → licht kunstwerk, lichte muur →
  // donker kunstwerk.
  function isDark(hex) {
    var c = hex.replace('#', '');
    var r = parseInt(c.slice(0, 2), 16);
    var g = parseInt(c.slice(2, 4), 16);
    var b = parseInt(c.slice(4, 6), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) < 150;
  }


  // ============================================================
  // STATE
  // ============================================================
  // stap            : 1–5  (stap 5 = resultaatpagina)
  // muurkleur       : id uit MUURKLEUREN (stap 1)
  // kleurKeuze      : 'blend' | 'statement'  (stap 2)
  // formaat         : 'vierkant' | 'rechthoek' | 'panorama'  (stap 3)
  // stijlen         : array van geselecteerde stijl-id's  (stap 4)
  // resultaatAantal : aantal aanbevolen designs (bepaalt header-tekst)

  var state = {};

  // ── GA4 tracking helper ──────────────────────────────────────
  // Valt stil als gtag niet geladen is (preview, ad-blocker, etc.)
  function khTrack(naam, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', naam, params || {});
    }
  }

  // Config-panel staat — wordt gereset bij elke openConfig()-aanroep.
  var cfg = {
    handle: null, naam: null, formaat: null, fallbackImg: null,
    kleurCode: null, maat: null, type: null, variantId: null,
    prijs: null, productData: null,
    directKleur: null  // ingesteld vanuit landing page: toon alleen deze kleur als "aanbevolen"
  };

  // Bijhoudt de geselecteerde kleur per design-kaart op de resultaatpagina.
  // Sleutel = design.handle, waarde = kleurcode (bijv. '435_NL').
  var kaartKleurState = {};

  // Product JSON cache: { handle → data }
  var productCache = {};

  // Bijhoudt of de hint-animatie loopt per carousel.
  // Voorkomt dat het scroll-event van de animatie de pijl verbergt.
  var hintAnimating = {};

  // Muur-visualisatie constanten (referentiewand 300×250 cm)
  var WAND_W_CM    = 300;
  var WAND_H_CM    = 250;
  var VLOER_PCT    = 0.16;   // vloerstrip = 16% van scènehoogte
  var TWIN_GAP_CM  = 10;     // gap tussen Twin-panelen in cm
  var OOG_H_CM     = 150;    // ooghoogte midden kunstwerk in cm
  var MENS_H_CM    = 175;    // menssilhouet hoogte in cm

  function resetState() {
    state = {
      stap:            1,
      muurkleur:       null,
      kleurKeuze:      null,
      formaat:         null,
      stijlen:         [],
      resultaatAantal: 0
    };
  }


  // ============================================================
  // AANBEVELINGSENGINE
  // ============================================================

  // ============================================================
  // KLEURWISSEL — helpers voor het wisselen van kleur op resultaatkaarten
  // ============================================================

  // Geeft de CDN-URL voor een kleur-specifieke afbeelding.
  // Formaat 'panorama' vertaalt naar 'langwerpig' in de bestandsnaam.
  // Kleurcode wordt lowercase: '435_NL' → '435_nl'.
  function getKleurImg(formaat, handle, typeSlug, kleurCode) {
    var slug = FORMAAT_SLUG[formaat] || formaat;
    var code = kleurCode.toLowerCase();
    return CDN_KLEUR + 'kh-kleur-' + slug + '-' + handle + '-' + typeSlug + '-' + code + '.jpg?v=20260419b';
  }

  // 6 aanbevolen kleuren voor de huidige muurkleur × blend/statement keuze,
  // met zwarte codes naar het einde geplaatst zodat de eerste kleur nooit zwart is.
  function kaartAanbevolenKleuren() {
    var codes = KLEUR_MATRIX[state.muurkleur][state.kleurKeuze].slice(0, 6);
    var zwart = codes.filter(function (c) { return ZWART_CODES.indexOf(c) >= 0; });
    var rest  = codes.filter(function (c) { return ZWART_CODES.indexOf(c) < 0; });
    return rest.concat(zwart);
  }

  // Wissel de afbeelding op een resultaatkaart en sla de keuze op in kaartKleurState.
  function kaartWisselKleur(handle, code) {
    if (GEEN_KLEUR_IMG.indexOf(handle) >= 0) return;
    kaartKleurState[handle] = code;
    var kaart = document.querySelector('.kh-kaart[data-handle="' + handle + '"]');
    if (!kaart) return;
    var imgEl    = kaart.querySelector('.kh-kaart-foto img');
    var fotoBtn  = kaart.querySelector('.kh-kaart-foto');
    var fallback = fotoBtn ? fotoBtn.dataset.img : '';
    if (imgEl) {
      var newSrc = getKleurImg(state.formaat, handle, 'inliggend', code);
      imgEl.style.opacity = '0.7';
      imgEl.onerror = function () { imgEl.src = fallback; imgEl.onerror = null; imgEl.style.opacity = '1'; };
      imgEl.onload  = function () { imgEl.style.opacity = '1'; imgEl.onload = null; };
      imgEl.src = newSrc;
    }
    kaart.querySelectorAll('.kh-kaart-swatch').forEach(function (s) {
      s.classList.toggle('kh-kaart-swatch--actief', s.dataset.code === code);
    });
    var labelEl = kaart.querySelector('.kh-kaart-kleur-label');
    if (labelEl && KLEUREN[code]) labelEl.textContent = KLEUREN[code].naam;
  }


  // berekenResultaat — selecteert max. 3 designs via round-robin.
  //
  // Algoritme: groepeer designs per geselecteerde stijl, loop dan
  // in rondes door de stijlen en pak steeds design[ronde].
  // Zo is de mix evenredig bij meerdere stijlkeuzes.
  // Voorbeeld: stijlen = [organisch, grafisch]
  //   ronde 0 → organisch[0], grafisch[0]
  //   ronde 1 → organisch[1]  (stop na 3)
  //
  // Geeft terug: { designs: [...], kleuren: [...6 codes] }
  function berekenResultaat() {
    var kleuren = KLEUR_MATRIX[state.muurkleur][state.kleurKeuze].slice(0, 6);

    var byStijl = {};
    state.stijlen.forEach(function (stijl) {
      byStijl[stijl] = DESIGNS[state.formaat].filter(function (d) {
        return d.stijl === stijl;
      });
    });

    var result = [];
    for (var round = 0; round < 3 && result.length < 3; round++) {
      state.stijlen.forEach(function (stijl) {
        if (result.length < 3 && byStijl[stijl] && byStijl[stijl][round]) {
          result.push(byStijl[stijl][round]);
        }
      });
    }

    state.resultaatAantal = result.length;
    return { designs: result, kleuren: kleuren };
  }


  // ============================================================
  // HEADER UPDATEN
  // ============================================================

  function updateHeader() {
    var balk        = document.getElementById('kh-voortgang-balk');
    var label       = document.getElementById('kh-stap-label');
    var terugBtn    = document.getElementById('kh-terug');
    var opnieuwBtn  = document.getElementById('kh-opnieuw-header');
    var zichtbaar   = state.stap > 1 ? 'visible' : 'hidden';

    if (balk) {
      balk.style.width = (Math.min(state.stap, 4) / 4 * 100) + '%';
    }
    if (label) {
      label.textContent = state.stap <= 4
        ? 'Stap ' + state.stap + ' van 4'
        : (state.resultaatAantal === 1 ? 'Onze aanbeveling' : 'Onze aanbevelingen');
    }
    if (terugBtn)   terugBtn.style.visibility   = zichtbaar;
    if (opnieuwBtn) opnieuwBtn.style.visibility = zichtbaar;
  }


  // ============================================================
  // RENDERERS — één functie per stap
  // ============================================================

  // Stap 1 — Muurkleur
  // Grid van 8 kleurpillen. Klik gaat direct door naar stap 2.
  function renderStap1() {
    return '<h2 class="kh-titel">Welke kleur heeft je muur?</h2>'
      + '<p class="kh-sub">Kies de kleur die het meest op jouw muur lijkt</p>'
      + '<div class="kh-kleur-grid">'
      + MUURKLEUREN.map(function (k) {
          return '<button class="kh-kleur-tile" data-waarde="' + k.id + '">'
            + '<span class="kh-kleur-vlak" style="background:' + k.hex + '"></span>'
            + '<span class="kh-kleur-naam">' + k.naam + '</span>'
            + '</button>';
        }).join('')
      + '</div>';
  }

  // Stap 2 — Blend vs Statement
  // Twee tiles met een kleurpreview (muur + kunstwerk naast elkaar).
  //   Blend:     kunstwerk krijgt dezelfde tint als de muur;
  //              de brightness-verlaging zit in CSS (.kh-keuze-kunst--blend).
  //   Statement: kunstwerk contrasteert; isDark() bepaalt of het
  //              licht (#F0F0EE) of donker (#1a1a1a) wordt.
  function renderStap2() {
    var muur         = MUURKLEUREN.find(function (k) { return k.id === state.muurkleur; });
    var muurHex      = muur ? muur.hex  : '#ccc';
    var muurNaam     = muur ? muur.naam.toLowerCase() : 'muur';
    var statementKleur = isDark(muurHex) ? '#F0F0EE' : '#1a1a1a';

    return '<h2 class="kh-titel">Hoe wil je het kunstwerk inzetten?</h2>'
      + '<p class="kh-sub">Ten opzichte van je ' + muurNaam + ' muur</p>'
      + '<div class="kh-keuze-grid">'
      + '<button class="kh-keuze-tile" data-waarde="blend">'
      + '<div class="kh-keuze-visual">'
      + '<div class="kh-keuze-muur" style="background:' + muurHex + '"></div>'
      + '<div class="kh-keuze-kunst kh-keuze-kunst--blend" style="background:' + muurHex + '"></div>'
      + '</div>'
      + '<strong>Blend</strong>'
      + '<p>Rustig &amp; ton-sur-ton</p>'
      + '<small>Het kunstwerk vloeit samen met de muur</small>'
      + '</button>'
      + '<button class="kh-keuze-tile" data-waarde="statement">'
      + '<div class="kh-keuze-visual">'
      + '<div class="kh-keuze-muur" style="background:' + muurHex + '"></div>'
      + '<div class="kh-keuze-kunst" style="background:' + statementKleur + '"></div>'
      + '</div>'
      + '<strong>Statement</strong>'
      + '<p>Opvallend &amp; contrasterend</p>'
      + '<small>Het kunstwerk springt eruit als blikvanger</small>'
      + '</button>'
      + '</div>';
  }

  // Stap 3 — Formaat
  // Drie tiles met proporionele CSS-preview-blokken.
  // kh-formaat-preview-wrap heeft een vaste hoogte zodat de teksten
  // verticaal uitlijnen ongeacht de hoogte van het preview-blok.
  function renderStap3() {
    return '<h2 class="kh-titel">Welk formaat past bij jouw ruimte?</h2>'
      + '<p class="kh-sub">Elk formaat heeft zijn eigen uitstraling</p>'
      + '<div class="kh-formaat-grid">'
      + FORMATEN.map(function (f) {
          return '<button class="kh-formaat-tile" data-waarde="' + f.id + '">'
            + '<div class="kh-formaat-preview-wrap">'
            + '<div class="kh-formaat-preview kh-formaat-preview--' + f.id + '"></div>'
            + '</div>'
            + '<strong>' + f.naam + '</strong>'
            + '<span class="kh-formaat-verhouding">' + f.verhouding + '</span>'
            + '<span class="kh-formaat-range">' + f.range + '</span>'
            + '</button>';
        }).join('')
      + '</div>';
  }

  // Stap 4 — Stijl (multi-select)
  // Tiles togglen actief/inactief; checkmarks worden direct in de DOM
  // bijgewerkt in bindStapListeners() om volledige re-renders te vermijden.
  // "Bekijk aanbevelingen"-knop wordt zichtbaar zodra ≥ 1 stijl geselecteerd is.
  function renderStap4() {
    var heeftKeuze = state.stijlen.length > 0;
    return '<h2 class="kh-titel">Welke stijl spreekt jou aan?</h2>'
      + '<p class="kh-sub">Kies één of meerdere stijlen</p>'
      + '<div class="kh-stijl-grid">'
      + STIJLEN.map(function (s) {
          var actief = state.stijlen.indexOf(s.id) !== -1;
          return '<button class="kh-stijl-tile' + (actief ? ' kh-stijl-tile--actief' : '') + '"'
            + ' data-waarde="' + s.id + '">'
            + '<div class="kh-stijl-illustratie">'
            + (actief ? '<span class="kh-stijl-check">&#10003;</span>' : '')
            + STIJL_SVGS[s.id]
            + '</div>'
            + '<div class="kh-stijl-info">'
            + '<strong>' + s.naam + '</strong>'
            + '<span>' + s.omschrijving + '</span>'
            + '</div>'
            + '</button>';
        }).join('')
      + '</div>'
      + '<button id="kh-stijl-next" class="kh-stijl-next-btn"'
      + ' style="visibility:' + (heeftKeuze ? 'visible' : 'hidden') + '">'
      + 'Bekijk aanbevelingen &rarr;'
      + '</button>';
  }

  // Stap 5 — Resultaat
  // Opgebouwd uit vier blokken:
  //   1. Keuze-samenvatting (chips met de gemaakte keuzes)
  //   2. Aanbevolen kleuren (grote swatches, 1× gedeeld voor alle kaarten)
  //   3. Informatieve afmeting-tiles (Subtiel → Eyecatcher + Twin)
  //   4. Design-kaarten (foto + naam + stijlbadge + CTA naar PDP)
  function renderResultaat() {
    var res     = berekenResultaat();
    var designs = res.designs;
    var kleuren = res.kleuren;
    var formaat = state.formaat;
    var maten   = AFMETINGEN[formaat];
    var muurObj = MUURKLEUREN.find(function (k) { return k.id === state.muurkleur; });
    var muurNaam = muurObj ? muurObj.naam : '';
    var muurHex  = muurObj ? muurObj.hex  : '#ccc';
    var stijlNamen = state.stijlen.map(function (id) {
      var s = STIJLEN.find(function (x) { return x.id === id; });
      return s ? s.naam : id;
    }).join(', ');

    khTrack('keuzehulp_resultaten', { aantal: designs.length });

    // Fallback: kan optreden als een stijl geen designs heeft voor dit formaat
    if (designs.length === 0) {
      return '<h2 class="kh-titel">Geen exacte match</h2>'
        + '<div class="kh-res-topnav">'
        + '<button class="kh-opnieuw" id="kh-opnieuw">&larr; Andere keuze</button>'
        + '<a href="/collections/akoestische-kunst" class="kh-alle-link">Alle kunstwerken &rarr;</a>'
        + '</div>'
        + '<p class="kh-sub">Bekijk onze volledige collectie voor meer inspiratie.</p>'
        + '<a href="/collections/akoestische-kunst" class="kh-cta-btn">Bekijk alle kunstwerken &rarr;</a>';
    }

    // 1. Keuze-samenvatting
    var samenvattingHTML = '<div class="kh-samenvatting">'
      + '<span class="kh-keuze-chip">'
      + '<span class="kh-keuze-dot" style="background:' + muurHex + ';border:1px solid rgba(0,0,0,0.12)"></span>'
      + muurNaam + '</span>'
      + '<span class="kh-keuze-chip">' + (state.kleurKeuze === 'blend' ? 'Blend' : 'Statement') + '</span>'
      + '<span class="kh-keuze-chip">' + (formaat.charAt(0).toUpperCase() + formaat.slice(1)) + '</span>'
      + '<span class="kh-keuze-chip">' + stijlNamen + '</span>'
      + '</div>';

    // 2. Aanbevolen kleuren
    // Swatches zijn klikbaar: klik opent een vergrote staalfoto binnen de drawer.
    // data-kleur-code wordt gebruikt door openSwatchLightbox() in de click-handler.
    var kleurLabel = state.kleurKeuze === 'blend'
      ? 'Aanbevolen kleuren (harmoniëren met je muur):'
      : 'Aanbevolen kleuren (vallen op op je muur):';
    var swatchesHTML = kleuren.map(function (code) {
      var k = KLEUREN[code];
      if (!k) return '';
      return '<button class="kh-swatch-item" data-kleur-code="' + code + '" aria-label="Vergroot ' + k.naam + '" title="' + k.naam + '">'
        + '<img class="kh-swatch kh-swatch--lg" src="' + k.img + '" alt="' + k.naam + '" loading="lazy" style="background:' + k.hex + '">'
        + '<span class="kh-swatch-naam">' + k.naam + '</span>'
        + '</button>';
    }).join('');

    // 3. Informatieve afmeting-tiles (Subtiel t/m Eyecatcher + Twin)
    var matenHTML = maten.map(function (maat, i) {
      var dims = maat.match(/(\d+)\D+(\d+)/);
      var dw = dims ? dims[1] : '0', dh = dims ? dims[2] : '0';
      return '<div class="kh-maat-info" data-w="' + dw + '" data-h="' + dh + '" data-twin="false"'
        + ' role="button" tabindex="0" aria-label="Bekijk ' + IMPACT_LABELS[i] + ' op de muur">'
        + '<span class="kh-maat-naam">' + IMPACT_LABELS[i] + '</span>'
        + '<span class="kh-maat-afm">' + maat + '</span>'
        + '</div>';
    }).join('');
    // Twin: Blikvanger (index 2) als basis
    var blikMaat = maten[2].match(/(\d+)\D+(\d+)/);
    var blikW = blikMaat ? blikMaat[1] : '0', blikH = blikMaat ? blikMaat[2] : '0';
    matenHTML += '<div class="kh-maat-info kh-maat-info--twin" data-w="' + blikW + '" data-h="' + blikH + '" data-twin="true"'
      + ' role="button" tabindex="0" aria-label="Bekijk Max impact Twin op de muur">'
      + '<span class="kh-maat-naam">Max impact</span>'
      + '<span class="kh-maat-afm">Twin &middot; 2 panelen</span>'
      + '</div>';

    // 4. Design-kaarten
    // Eerste aanbevolen kleur (niet-zwart) als beginstaat voor elke kaart.
    var collectie    = COLLECTIES[formaat];
    var aanbevKleuren = kaartAanbevolenKleuren();
    var firstKleur   = aanbevKleuren[0];
    // Muurkleur uit stap 1 als achtergrond achter de afbeelding
    var muurEntry = MUURKLEUREN.find(function(m) { return m.id === state.muurkleur; }) || MUURKLEUREN[0];
    var muurHex   = muurEntry.hex;

    var kaartenHTML = designs.map(function (design) {
      var pdpUrl    = '/collections/' + collectie + '/products/' + design.handle;
      var stijlInfo = STIJLEN.find(function (s) { return s.id === design.stijl; });
      var stijlBadge = stijlInfo
        ? '<span class="kh-kaart-stijl">' + stijlInfo.naam + '</span>'
        : '';

      // Initialiseer kaartkleur met eerste aanbevolen kleur
      var heeftKleurImg = GEEN_KLEUR_IMG.indexOf(design.handle) < 0;
      kaartKleurState[design.handle] = firstKleur;
      var initImg = heeftKleurImg
        ? getKleurImg(formaat, design.handle, 'inliggend', firstKleur)
        : design.img;

      // Swatch-rij: alleen tonen voor designs met kleurafbeeldingen
      var swatchRij = heeftKleurImg ? aanbevKleuren.map(function (code) {
        var k = KLEUREN[code];
        if (!k) return '';
        var actief = (code === firstKleur) ? ' kh-kaart-swatch--actief' : '';
        return '<button class="kh-kaart-swatch' + actief + '"'
          + ' data-design="' + design.handle + '"'
          + ' data-code="' + code + '"'
          + ' title="' + k.naam + '"'
          + ' aria-label="Toon in ' + k.naam + '">'
          + '<img src="' + k.img + '" width="28" height="28" loading="lazy" alt="' + escAttr(k.naam) + '">'
          + '</button>';
      }).join('') : '';

      return '<div class="kh-kaart" data-handle="' + design.handle + '">'
        + '<div class="kh-kaart-foto kh-kaart-foto--' + formaat + '"'
        + ' data-handle="' + design.handle + '"'
        + ' data-naam="' + escAttr(design.naam) + '"'
        + ' data-img="' + escAttr(design.img) + '"'
        + ' style="background:' + muurHex + '">'
        + '<img src="' + initImg + '" alt="" loading="lazy"'
        + ' data-fallback="' + escAttr(design.img) + '"'
        + ' onerror="this.src=this.dataset.fallback;this.onerror=null;">'
        + '</div>'
        + (swatchRij ? '<div class="kh-kaart-swatches">' + swatchRij + '</div>' : '')
        + (heeftKleurImg ? '<div class="kh-kaart-kleur-label">' + escHtml(KLEUREN[firstKleur] ? KLEUREN[firstKleur].naam : '') + '</div>' : '')
        + '<div class="kh-kaart-info">'
        + stijlBadge
        + '<h3 class="kh-kaart-naam">' + design.naam + '</h3>'
        + '<button class="kh-cfg-btn"'
        + ' data-handle="' + design.handle + '"'
        + ' data-naam="' + escAttr(design.naam) + '"'
        + ' data-img="' + escAttr(design.img) + '">'
        + '<svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M8 3v10M3 8h10"/></svg>'
        + ' Samenstellen &amp; bestellen'
        + '</button>'
        + '<a href="' + pdpUrl + '" class="kh-cfg-sec">Bekijk product &rarr;</a>'
        + '</div>'
        + '</div>';
    }).join('');

    var titleText = designs.length === 1 ? 'Onze aanbeveling voor jou' : 'Onze aanbevelingen voor jou';

    // 5. Kinderkaart — verwijzing naar de kindercollectie, alleen bij rechthoek
    var kinderHTML = '';
    if (formaat === 'rechthoek') {
      kinderHTML = '<a class="kh-kinder-kaart" href="' + KINDER_COLLECTIE.url + '">'
        + '<span class="kh-kinder-fotos" aria-hidden="true">'
        + KINDER_COLLECTIE.fotos.map(function (src) {
            return '<img class="kh-kinder-foto" src="' + src + '" alt="" loading="lazy">';
          }).join('')
        + '</span>'
        + '<span class="kh-kinder-tekst">'
        + '<span class="kh-kinder-titel">Ook iets voor de kinderkamer?</span>'
        + '<span class="kh-kinder-sub">6 vrolijke dieren &middot; 60&times;90 cm &middot; akoestisch vilt</span>'
        + '<span class="kh-kinder-link">Bekijk de kindercollectie <span aria-hidden="true">&rarr;</span></span>'
        + '</span>'
        + '</a>';
    }

    return '<h2 class="kh-titel">' + titleText + '</h2>'
      + '<div class="kh-res-topnav">'
      + '<button class="kh-opnieuw" id="kh-opnieuw">&larr; Andere keuze</button>'
      + '<a href="/collections/akoestische-kunst" class="kh-alle-link">Alle kunstwerken &rarr;</a>'
      + '</div>'
      + '<p class="kh-keuzes-label">Jouw gemaakte keuzes:</p>'
      + samenvattingHTML
      + '<div class="kh-kleur-blok kh-kleur-blok--top">'
      + '<p class="kh-kleur-label">' + kleurLabel + '</p>'
      + '<div class="kh-carousel-wrap" id="kh-wrap-kleuren">'
      + '<button class="kh-nav-pijl kh-nav-pijl--l" id="kh-pijl-l-kleuren" aria-label="Scroll links" hidden><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 3L6 8l4 5"/></svg></button>'
      + '<div class="kh-swatches kh-carousel" id="kh-carousel-kleuren">' + swatchesHTML + '</div>'
      + '<button class="kh-nav-pijl kh-nav-pijl--r" id="kh-pijl-r-kleuren" aria-label="Scroll rechts" hidden><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3l4 5-4 5"/></svg></button>'
      + '</div>'
      + '</div>'
      + '<p class="kh-kleur-label">Aanbevolen kunstwerken:</p>'
      + '<div class="kh-carousel-wrap" id="kh-wrap-kaarten">'
      + '<button class="kh-nav-pijl kh-nav-pijl--l" id="kh-pijl-l-kaarten" aria-label="Scroll links" hidden><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 3L6 8l4 5"/></svg></button>'
      + '<div class="kh-kaarten kh-carousel" id="kh-carousel-kaarten">' + kaartenHTML + '</div>'
      + '<button class="kh-nav-pijl kh-nav-pijl--r" id="kh-pijl-r-kaarten" aria-label="Scroll rechts" hidden><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3l4 5-4 5"/></svg></button>'
      + '</div>'
      + '<div class="kh-afmeting-blok kh-afmeting-blok--top">'
      + '<p class="kh-kleur-label">Passende afmetingen:</p>'
      + '<div class="kh-carousel-wrap" id="kh-wrap-maten">'
      + '<button class="kh-nav-pijl kh-nav-pijl--l" id="kh-pijl-l-maten" aria-label="Scroll links" hidden><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 3L6 8l4 5"/></svg></button>'
      + '<div class="kh-maten-info kh-carousel" id="kh-carousel-maten">' + matenHTML + '</div>'
      + '<button class="kh-nav-pijl kh-nav-pijl--r" id="kh-pijl-r-maten" aria-label="Scroll rechts" hidden><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3l4 5-4 5"/></svg></button>'
      + '</div>'
      + '</div>'
      + kinderHTML;
  }


  // ============================================================
  // RESULTAAT-CAROUSELS — horizontaal scrollbare secties
  // ============================================================
  // Drie carousels op de resultaatpagina: kleuren, maten, kaarten.
  // Elke carousel heeft:
  //   • Een scroll-pijl die verdwijnt bij eerste gebruikersscroll
  //   • Een fade-gradient rechts als er meer content is
  //   • Een hint-animatie die de gebruiker laat zien dat hij kan scrollen
  //
  // hintAnimating: vlag per carousel die voorkomt dat het scroll-event
  // van de hint-animatie de pijl prematuur verbergt.

  function initResultaatCarousels() {
    ['kleuren', 'maten', 'kaarten'].forEach(function(id, i) {
      initKhCarousel(id);
      scrollHintKh(id, i * 400 + 300);
    });
  }

  function initKhCarousel(id) {
    var carousel   = document.getElementById('kh-carousel-' + id);
    var wrap       = document.getElementById('kh-wrap-' + id);
    var pijlLinks  = document.getElementById('kh-pijl-l-' + id);
    var pijlRechts = document.getElementById('kh-pijl-r-' + id);
    if (!carousel || !wrap) return;

    hintAnimating[id] = false;

    // Toon/verberg pijlen op basis van scroll-positie.
    // Onderdrukt linker-pijl tijdens hint-animatie om flikkering te voorkomen.
    function updatePijlen() {
      if (hintAnimating[id]) return;
      var sl      = carousel.scrollLeft;
      var hasLeft = sl > 4;
      var hasRight = sl + carousel.clientWidth < carousel.scrollWidth - 4;
      if (pijlLinks)  pijlLinks.hidden  = !hasLeft;
      if (pijlRechts) pijlRechts.hidden = !hasRight;
      wrap.classList.toggle('kh-carousel-wrap--meer', hasRight);
    }

    if (pijlLinks) {
      pijlLinks.addEventListener('click', function () {
        // Scroll naar het dichtstbijzijnde item links van de huidige positie
        var sl    = carousel.scrollLeft;
        var items = carousel.children;
        var doel  = 0;
        for (var i = items.length - 1; i >= 0; i--) {
          if (items[i].offsetLeft < sl - 4) { doel = items[i].offsetLeft; break; }
        }
        carousel.scrollTo({ left: doel, behavior: 'smooth' });
      });
    }
    if (pijlRechts) {
      pijlRechts.addEventListener('click', function () {
        // Scroll naar het eerste item rechts van de huidige positie
        var sl    = carousel.scrollLeft;
        var items = carousel.children;
        for (var i = 0; i < items.length; i++) {
          if (items[i].offsetLeft > sl + 4) {
            carousel.scrollTo({ left: items[i].offsetLeft, behavior: 'smooth' });
            return;
          }
        }
      });
    }

    carousel.addEventListener('scroll', updatePijlen, { passive: true });
    window.addEventListener('resize', updatePijlen);

    updatePijlen();
  }

  // scrollHintKh — scrolt licht naar rechts en terug als visuele hint.
  // scroll-snap-type wordt tijdelijk uitgeschakeld om te voorkomen dat
  // de browser na afloop naar een snap-punt snapped dat niet scrollLeft=0 is.
  function scrollHintKh(id, delay) {
    var el = document.getElementById('kh-carousel-' + id);
    if (!el) return;
    var peek = 52, duur = 700;

    function ease(t) { return t < 0.45 ? t / 0.45 : 1 - (t - 0.45) / 0.55; }

    setTimeout(function() {
      if (el.scrollWidth <= el.clientWidth + 4) return;
      hintAnimating[id] = true;
      el.style.scrollSnapType = 'none';
      var startTime = null;
      function frame(ts) {
        if (!startTime) startTime = ts;
        var p = Math.min((ts - startTime) / duur, 1);
        el.scrollLeft = ease(p) * peek;
        if (p < 1) {
          requestAnimationFrame(frame);
        } else {
          el.scrollLeft = 0;
          setTimeout(function() {
            el.style.scrollSnapType = '';
            hintAnimating[id] = false;
          }, 50);
        }
      }
      requestAnimationFrame(frame);
    }, delay);
  }


  // ============================================================
  // RENDER — centrale renderfunctie
  // ============================================================

  function render() {
    var body = document.getElementById('kh-body');
    if (!body) return;
    switch (state.stap) {
      case 1: body.innerHTML = renderStap1();    break;
      case 2: body.innerHTML = renderStap2();    break;
      case 3: body.innerHTML = renderStap3();    break;
      case 4: body.innerHTML = renderStap4();    break;
      case 5: body.innerHTML = renderResultaat(); break;
    }
    updateHeader();
    bindStapListeners();
    body.scrollTop = 0;

    // Carousels initialiseren na het renderen van de resultaatpagina.
    // Dubbele requestAnimationFrame zorgt dat de browser de layout
    // heeft berekend voordat we scrollWidth meten.
    if (state.stap === 5) {
      requestAnimationFrame(function() {
        requestAnimationFrame(initResultaatCarousels);
      });
    }
  }


  // ============================================================
  // EVENT LISTENERS — per stap, na elke render opnieuw gebonden
  // ============================================================
  // Wordt aangeroepen ná elke render(). Door de innerHTML-vervanging
  // worden alle oude listeners automatisch opgeruimd met de oude DOM.

  function bindStapListeners() {

    // Stap 1: muurkleur kiezen → direct naar stap 2
    document.querySelectorAll('.kh-kleur-tile').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.muurkleur = btn.dataset.waarde;
        khTrack('keuzehulp_stap1', { muurkleur: btn.dataset.waarde });
        state.stap = 2;
        render();
      });
    });

    // Stap 2: blend/statement kiezen → direct naar stap 3
    document.querySelectorAll('.kh-keuze-tile').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.kleurKeuze = btn.dataset.waarde;
        khTrack('keuzehulp_stap2', { kleurkeuze: btn.dataset.waarde });
        state.stap = 3;
        render();
      });
    });

    // Stap 3: formaat kiezen → direct naar stap 4
    document.querySelectorAll('.kh-formaat-tile').forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.formaat = btn.dataset.waarde;
        khTrack('keuzehulp_stap3', { formaat: btn.dataset.waarde });
        state.stap = 4;
        render();
      });
    });

    // Stap 4: stijl togglen (multi-select)
    // Checkmarks worden direct in de bestaande DOM bijgewerkt
    // zodat de hele stap niet opnieuw gerenderd hoeft te worden.
    document.querySelectorAll('.kh-stijl-tile').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var waarde = btn.dataset.waarde;
        var idx    = state.stijlen.indexOf(waarde);

        if (idx === -1) {
          // Stijl toevoegen
          state.stijlen.push(waarde);
          btn.classList.add('kh-stijl-tile--actief');
          var ill = btn.querySelector('.kh-stijl-illustratie');
          if (ill && !ill.querySelector('.kh-stijl-check')) {
            var chk = document.createElement('span');
            chk.className   = 'kh-stijl-check';
            chk.textContent = '\u2713';
            ill.insertBefore(chk, ill.firstChild);
          }
        } else {
          // Stijl verwijderen
          state.stijlen.splice(idx, 1);
          btn.classList.remove('kh-stijl-tile--actief');
          var existingChk = btn.querySelector('.kh-stijl-check');
          if (existingChk) existingChk.parentNode.removeChild(existingChk);
        }

        // "Bekijk aanbevelingen"-knop tonen/verbergen
        var nextBtn = document.getElementById('kh-stijl-next');
        if (nextBtn) nextBtn.style.visibility = state.stijlen.length > 0 ? 'visible' : 'hidden';
      });
    });

    // Stap 4: "Bekijk aanbevelingen" knop → naar stap 5
    var stijlNext = document.getElementById('kh-stijl-next');
    if (stijlNext) {
      stijlNext.addEventListener('click', function () {
        if (state.stijlen.length > 0) {
          khTrack('keuzehulp_stap4', { stijlen: state.stijlen.join(',') });
          state.stap = 5;
          render();
        }
      });
    }

    // Resultaat: "Andere keuze" → volledig resetten naar stap 1
    var opnieuw = document.getElementById('kh-opnieuw');
    if (opnieuw) {
      opnieuw.addEventListener('click', function () { resetState(); render(); });
    }
  }


  // ============================================================
  // PAGINA-DETECTIE — bepaalt of de side tab getoond wordt
  // ============================================================

  // isAkoestischPagina — geeft true op:
  //   PLP: URL bevat /collections/akoestisch
  //   PDP: body heeft class template-product (alle Petterns-producten)
  // Pas aan als de side tab op andere pagina's gewenst is.
  function isAkoestischPagina() {
    var path = document.location.pathname.toLowerCase();
    if (path.indexOf('/collections/akoestisch') !== -1) return true;
    if (document.body.className.toLowerCase().indexOf('template-product') !== -1) return true;
    return false;
  }

  function tabTonen() {
    var tab = document.getElementById('kh-side-tab');
    if (tab && isAkoestischPagina()) tab.style.display = 'flex';
  }

  function tabVerbergen() {
    var tab = document.getElementById('kh-side-tab');
    if (tab) tab.style.visibility = 'hidden';
  }

  function tabHerstellen() {
    var tab = document.getElementById('kh-side-tab');
    if (tab && isAkoestischPagina()) tab.style.visibility = 'visible';
  }


  // ============================================================
  // SWATCH LIGHTBOX — vergrote kleurstaalfoto binnen de drawer
  // ============================================================
  // De lightbox is een overlay met position:absolute binnen #kh-modal,
  // zodat hij de drawer vult maar de rest van de pagina onaangeroerd laat.
  // Geen aparte popup: alles speelt zich af binnen de bestaande drawer.

  function openSwatchLightbox(code) {
    var k = KLEUREN[code];
    if (!k) return;

    // Verwijder eventuele bestaande lightbox
    closeSwatchLightbox();

    var modal = document.getElementById('kh-modal');
    if (!modal) return;

    // Adaptieve achtergrond: donker staal → lichte bg, licht staal → donkere bg.
    // Zo is het staal altijd goed zichtbaar, ongeacht de kleur.
    var donker    = isDark(k.hex);
    var bg        = donker ? '#EDE8E2'                    : 'rgba(15,15,15,0.94)';
    var tekstkleur = donker ? '#2a2a2a'                   : '#ffffff';
    var btnBg     = donker ? 'rgba(0,0,0,0.10)'           : 'rgba(255,255,255,0.15)';
    var btnBorder = donker ? 'rgba(0,0,0,0.18)'           : 'rgba(255,255,255,0.25)';
    var btnKleur  = donker ? '#333'                       : '#fff';

    var lb = document.createElement('div');
    lb.id = 'kh-swatch-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-label', 'Vergroot kleurstaal: ' + k.naam);
    lb.style.background = bg;

    lb.innerHTML = '<button id="kh-lightbox-sluiten" aria-label="Sluit vergroting"'
      + ' style="background:' + btnBg + ';border-color:' + btnBorder + ';color:' + btnKleur + '">&times;</button>'
      + '<img src="' + k.img + '" alt="' + k.naam + '">'
      + '<p class="kh-lightbox-naam" style="color:' + tekstkleur + '">' + k.naam + '</p>';

    // Klik buiten de foto (op de achtergrond) sluit de lightbox
    lb.addEventListener('click', function (e) {
      if (e.target === lb) closeSwatchLightbox();
    });

    modal.appendChild(lb);
  }

  function closeSwatchLightbox() {
    var existing = document.getElementById('kh-swatch-lightbox');
    if (existing) existing.parentNode.removeChild(existing);
  }


  // ============================================================
  // MUUR-VISUALISATIE — proportionele muurscène per afmeting
  // ============================================================
  // Klik op een .kh-maat-info tile toont een overlay met de referentiewand
  // (300×250 cm) en het kunstwerk op schaal, met een menssilhouet (175 cm)
  // als schaalreferentie.
  // Positilogica:
  //   - Standaard: midden kunstwerk op ooghoogte (150 cm)
  //   - Uitzondering: als artwork + ooghoogte het plafond doorbreekt (artH > 200 cm),
  //     wordt de onderkant op de vloer verankerd (grootste Panorama).

  function openMaatPreview(artW, artH, naam, isTwin) {
    closeMaatPreview();

    var modal = document.getElementById('kh-modal');
    if (!modal) return;

    var lb = document.createElement('div');
    lb.id = 'kh-maat-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Muurvisualisatie: ' + naam);

    lb.innerHTML = '<button id="kh-maat-lb-sluiten" aria-label="Sluit muurvisualisatie">&times;</button>'
      + '<div id="kh-muur-scene">'
      + '<div class="kh-muur-vloer"></div>'
      + '<div class="kh-muur-plint"></div>'
      + '</div>'
      + '<p class="kh-maat-preview-naam" id="kh-maat-preview-naam"></p>'
      + '<p class="kh-maat-preview-ref">Schaal\u2009\u2014\u2009referentiemuur 300\u00d7250\u2009cm</p>';

    lb.addEventListener('click', function (e) {
      if (e.target === lb) closeMaatPreview();
    });

    modal.appendChild(lb);

    // RAF: wacht tot DOM gerenderd is zodat clientWidth/Height kloppen
    requestAnimationFrame(function () {
      var scene = document.getElementById('kh-muur-scene');
      if (!scene) return;

      var sceneW  = scene.clientWidth;
      var sceneH  = scene.clientHeight;
      var vloerPx = sceneH * VLOER_PCT;
      var wandH   = sceneH - vloerPx;
      var scale   = Math.min(sceneW / WAND_W_CM, wandH / WAND_H_CM);

      var artWpx  = artW * scale;
      var artHpx  = artH * scale;

      // Positie: ooghoogte of vloer-verankerd
      var topCm  = OOG_H_CM + artH / 2;
      var artTop = topCm > WAND_H_CM
        ? wandH - artHpx                 // onderkant op vloer
        : wandH - topCm * scale;

      // Kunstwerk HTML
      var artHTML = '';
      if (isTwin) {
        var gapPx  = TWIN_GAP_CM * scale;
        var totW   = artWpx * 2 + gapPx;
        var startX = (sceneW - totW) / 2;
        artHTML += khArtDiv(startX, artTop, artWpx, artHpx);
        artHTML += khArtDiv(startX + artWpx + gapPx, artTop, artWpx, artHpx);
      } else {
        artHTML += khArtDiv((sceneW - artWpx) / 2, artTop, artWpx, artHpx);
      }

      // Menssilhouet rechts van het kunstwerk
      var mensHpx  = MENS_H_CM * scale;
      var mensWpx  = mensHpx * 0.28;
      var mensLeft = isTwin
        ? (sceneW + artWpx * 2 + TWIN_GAP_CM * scale) / 2 + 10
        : (sceneW + artWpx) / 2 + 10;
      if (mensLeft + mensWpx > sceneW - 4) mensLeft = sceneW - mensWpx - 4;

      scene.innerHTML = '<div class="kh-muur-vloer"></div>'
        + '<div class="kh-muur-plint"></div>'
        + artHTML
        + khMens(mensWpx, mensHpx, mensLeft, vloerPx);

      // Label
      var afmTekst = isTwin
        ? '2\u00d7 ' + artW + '\u00d7' + artH + '\u2009cm'
        : artW + '\u00d7' + artH + '\u2009cm';
      var el = document.getElementById('kh-maat-preview-naam');
      if (el) el.textContent = naam + ' \u00b7 ' + afmTekst;
    });
  }

  function closeMaatPreview() {
    var el = document.getElementById('kh-maat-lightbox');
    if (el) el.parentNode.removeChild(el);
  }

  function khArtDiv(x, y, w, h) {
    return '<div class="kh-muur-art" style="'
      + 'left:'   + x.toFixed(1) + 'px;'
      + 'top:'    + y.toFixed(1) + 'px;'
      + 'width:'  + w.toFixed(1) + 'px;'
      + 'height:' + h.toFixed(1) + 'px'
      + '"></div>';
  }

  // Menssilhouet SVG — voeten exact op y=140 (onderrand viewBox)
  // zodat bottom:vloerPx de voeten naadloos op de vloerlijn plaatst.
  function khMens(breedte, hoogte, leftPx, vloerPx) {
    return '<svg class="kh-muur-mens"'
      + ' width="'  + breedte.toFixed(1) + '"'
      + ' height="' + hoogte.toFixed(1)  + '"'
      + ' style="left:' + leftPx.toFixed(1) + 'px;bottom:' + vloerPx.toFixed(1) + 'px"'
      + ' viewBox="0 0 40 140" fill="#6a6460" aria-hidden="true">'
      + '<circle cx="20" cy="11" r="10"/>'
      + '<path d="M13 22 Q10 24 10 36 L10 76 Q10 79 20 79 Q30 79 30 76 L30 36 Q30 24 27 22 Q20 20 13 22Z"/>'
      + '<path d="M13 28 Q6 32 5 62 L9 63 Q9 38 15 32Z"/>'
      + '<path d="M27 28 Q34 32 35 62 L31 63 Q31 38 25 32Z"/>'
      + '<path d="M12 76 L9 140 L17 140 L19 80Z"/>'
      + '<path d="M28 76 L31 140 L23 140 L21 80Z"/>'
      + '</svg>';
  }


  // ============================================================
  // CONFIG PANEL — Samenstellen & bestellen
  // ============================================================
  // Schuift van rechts over de resultaatpagina. Laadt productdata
  // live vanuit /products/{handle}.js en laat de bezoeker kleur,
  // afmeting en type kiezen voordat het product in de winkelmand
  // wordt geplaatst via POST /cart/add.js.

  // Bouwt de "meer kleuren" grid opnieuw op, met uitsluiting van de getoonde kleuren.
  function buildMeerKleurenGrid() {
    var grid = document.getElementById('cfg-meer-kleuren-grid');
    if (!grid) return;
    // Vanuit landing page: sluit alleen de gekozen kleur uit; anders de 6 aanbevolen
    var aanbevolen = cfg.directKleur ? [cfg.directKleur] : cfgAanbevolenKleuren();
    grid.innerHTML = '';
    Object.keys(KLEUREN).forEach(function (code) {
      if (aanbevolen.indexOf(code) >= 0) return;
      var k = KLEUREN[code];
      var el = document.createElement('button');
      el.className = 'cfg-swatch--sm';
      el.title = k.naam;
      el.setAttribute('aria-label', k.naam);
      el.setAttribute('data-code', code);
      el.innerHTML = '<img src="' + k.img + '" width="34" height="34" loading="lazy" alt="' + escAttr(k.naam) + '">';
      grid.appendChild(el);
    });
  }

  // Werkt de grote afbeelding in het config panel bij op basis van
  // de geselecteerde kleur en het geselecteerde type.
  // Toont de kleur-specifieke afbeelding voor Inliggend/Opliggend;
  // voor Twin (geen kleur-afbeelding beschikbaar) of als geen kleur
  // gekozen is, toont het de fallback-URL.
  function cfgUpdateImg(fallback) {
    var imgEl = document.getElementById('cfg-img');
    if (!imgEl) return;
    var fb = fallback || cfg.fallbackImg || '';

    var typeSlug = null;
    if      (cfg.type === TYPES[0].waarde) typeSlug = 'inliggend';
    else if (cfg.type === TYPES[1].waarde) typeSlug = 'opliggend';
    else if (!cfg.type)                    typeSlug = 'inliggend';  // preview vóór type-keuze

    if (cfg.kleurCode && typeSlug && cfg.formaat && cfg.handle) {
      var url = getKleurImg(cfg.formaat, cfg.handle, typeSlug, cfg.kleurCode);
      imgEl.style.opacity = '0.6';
      imgEl.onerror = function () { imgEl.src = fb; imgEl.onerror = null; imgEl.style.opacity = '1'; };
      imgEl.onload  = function () { imgEl.style.opacity = '1'; imgEl.onload = null; };
      imgEl.src = url;
    } else if (fb) {
      imgEl.style.opacity = '0.6';
      imgEl.onerror = null;
      imgEl.src = fb;
      imgEl.onload = function () { imgEl.style.opacity = '1'; imgEl.onload = null; };
    }
  }

  // Haal Shopify product JSON op (met cache)
  function laadProduct(handle, cb) {
    if (productCache[handle]) { cb(productCache[handle]); return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (d) { productCache[handle] = d; cb(d); })
      .catch(function () { cb(null); });
  }

  // Zoek variant op basis van kleur × maat × type
  function vindVariant(data, kleurCode, maat, type) {
    if (!data) return null;
    var vk = KLEUREN[kleurCode] ? KLEUREN[kleurCode].variantKleur : 'Zand';
    var sm = maatShopify(maat);
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if (v.option1 === vk && v.option2 === sm && v.option3 === type) return v;
    }
    return null;
  }

  // Haal aanbevolen kleuren op voor huidige muurkleur × blend/statement
  function cfgAanbevolenKleuren() {
    if (state.muurkleur && state.kleurKeuze && KLEUR_MATRIX[state.muurkleur]) {
      return KLEUR_MATRIX[state.muurkleur][state.kleurKeuze].slice(0, 6);
    }
    return ['20', '88', '32', '124_NL', '12', '40'];
  }

  // Config panel openen
  function openConfig(handle, naam, startImg) {
    // Bewaar pendingType vóór reset — wordt gezet door landing-page click handler
    var savedPendingType = cfg.pendingType || null;
    // Herstel de eerder gekozen kaartkleur als beginwaarde, anders eerste aanbevolen kleur
    var initialKleur = kaartKleurState[handle] || cfgAanbevolenKleuren()[0];
    cfg = {
      handle: handle, naam: naam, formaat: state.formaat, fallbackImg: startImg,
      kleurCode: null, maat: null, type: null, variantId: null,
      prijs: null, productData: null,
      // Vanuit landing page: toon alleen de gekozen kleur als swatch (rest via meer kleuren)
      directKleur: state.directMode ? initialKleur : null,
      pendingType: savedPendingType
    };
    khTrack('keuzehulp_product_open', { product: naam });

    // Header
    var imgEl = document.getElementById('cfg-img');
    if (imgEl) {
      imgEl.alt = naam; imgEl.style.opacity = '1';
      // Muurkleur uit stap 1 als achtergrond achter het kunstwerk
      var muurCfgEntry = MUURKLEUREN.find(function(m){ return m.id === state.muurkleur; });
      if (muurCfgEntry) imgEl.style.background = muurCfgEntry.hex;
    }
    var naamEl = document.getElementById('cfg-naam');
    if (naamEl) naamEl.textContent = naam;
    var metaEl = document.getElementById('cfg-meta');
    if (metaEl) metaEl.textContent = 'Productinfo laden\u2026';

    // Kleuren renderen, meer-grid herbouwen (zonder de 6 aanbevolen),
    // daarna de initiële kleur selecteren (zet ook de afbeelding).
    renderCfgAanbevolenKleuren();
    buildMeerKleurenGrid();
    cfgKiesKleur(initialKleur);

    // Afmeting tiles renderen (op basis van state.formaat)
    renderCfgAfmetingen();

    // Type skeleton tonen
    renderTypesSkeleton();

    // Meer kleuren sluiten
    var grid = document.getElementById('cfg-meer-kleuren-grid');
    var mBtn = document.getElementById('cfg-meer-btn');
    if (grid) grid.classList.remove('open');
    if (mBtn) mBtn.textContent = '+ Meer kleuren';

    // Success verbergen, form tonen, bottom tonen + knop resetten
    var scroll = document.getElementById('cfg-scroll');
    var success = document.getElementById('cfg-success');
    var bottom  = document.getElementById('cfg-bottom');
    var btnEl   = document.getElementById('btn-incart');
    if (scroll)  scroll.style.display = '';
    if (success) success.classList.remove('show');
    if (bottom)  bottom.style.display = 'flex';
    if (btnEl) {
      btnEl.disabled = true;
      btnEl.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18"/><path d="M16 10a4 4 0 01-8 0"/></svg> In winkelmand';
    }
    cfgUpdatePrijs(null);

    // Header aanpassen
    var labelEl = document.getElementById('kh-stap-label');
    var opnieuw = document.getElementById('kh-opnieuw-header');
    var terug   = document.getElementById('kh-terug');
    if (labelEl) labelEl.textContent = naam + ' samenstellen';
    if (opnieuw) opnieuw.style.visibility = 'hidden';
    if (terug)   terug.style.visibility   = 'visible';

    // Inslide
    document.getElementById('kh-body').classList.add('kh-body--vers');
    document.getElementById('kh-config-panel').classList.add('kh-config-open');
    document.getElementById('kh-config-panel').setAttribute('aria-hidden', 'false');

    // Product ophalen
    laadProduct(handle, function (data) {
      if (!data) {
        if (metaEl) metaEl.textContent = 'Kon productdata niet laden';
        renderTypesFallback();
        return;
      }
      cfg.productData = data;
      if (metaEl) metaEl.textContent = data.title;

      // Afbeelding per type via variant.featured_image.
      // Pass 1: Zand-variant heeft de voorkeur (neutrale kleur, herkenbare foto).
      // Pass 2: fallback op elke andere variant als Zand geen featured_image heeft
      //         (bijv. Twin waaraan Shopify geen Zand-foto heeft gekoppeld).
      var typeImages = {};
      data.variants.forEach(function (v) {
        if (v.option1 === 'Zand' && v.featured_image && !typeImages[v.option3]) {
          typeImages[v.option3] = v.featured_image.src;
        }
      });
      data.variants.forEach(function (v) {
        if (!typeImages[v.option3] && v.featured_image) {
          typeImages[v.option3] = v.featured_image.src;
        }
      });

      renderTypes(typeImages);
      cfgUpdateVariant();
    });
  }

  // Config panel sluiten
  function sluitConfig() {
    document.getElementById('kh-body').classList.remove('kh-body--vers');
    document.getElementById('kh-config-panel').classList.remove('kh-config-open');
    document.getElementById('kh-config-panel').setAttribute('aria-hidden', 'true');

    // Vanuit landing page (directMode): sluit de hele drawer
    if (state.directMode) {
      state.directMode = false;
      close();
      return;
    }

    // Header terug naar resultaat-staat
    var labelEl = document.getElementById('kh-stap-label');
    var opnieuw = document.getElementById('kh-opnieuw-header');
    if (labelEl) labelEl.textContent = state.resultaatAantal === 1 ? 'Onze aanbeveling' : 'Onze aanbevelingen';
    if (opnieuw) opnieuw.style.visibility = 'visible';
  }

  // Aanbevolen kleuren renderen in het config panel
  function renderCfgAanbevolenKleuren() {
    var wrap = document.getElementById('cfg-swatches-aanbevolen');
    if (!wrap) return;
    wrap.innerHTML = '';
    // Vanuit landing page: toon alleen de geselecteerde kleur; rest via meer kleuren
    var lijst = cfg.directKleur ? [cfg.directKleur] : cfgAanbevolenKleuren();
    lijst.forEach(function (code) {
      var k = KLEUREN[code];
      if (!k) return;
      wrap.appendChild(maakCfgSwatch(code, k, 'cfg-swatch'));
    });
  }

  function maakCfgSwatch(code, k, cls) {
    var el = document.createElement('button');
    el.className = cls;
    el.title = k.naam;
    el.setAttribute('aria-label', k.naam);
    el.setAttribute('data-code', code);
    el.innerHTML = '<img src="' + k.img + '" width="40" height="40" loading="lazy" alt="' + escAttr(k.naam) + '">';
    return el;
  }

  function toggleMeerKleuren() {
    var grid = document.getElementById('cfg-meer-kleuren-grid');
    var btn  = document.getElementById('cfg-meer-btn');
    if (!grid) return;
    var open = grid.classList.toggle('open');
    if (btn) btn.textContent = open ? '\u2212 Minder kleuren' : '+ Meer kleuren';
  }

  // Afmeting tiles renderen vanuit AFMETINGEN[state.formaat]
  function renderCfgAfmetingen() {
    var wrap = document.getElementById('cfg-maten');
    if (!wrap) return;
    var maten   = AFMETINGEN[state.formaat] || AFMETINGEN.vierkant;
    var impacts = ['Subtiel', 'Opvallend', 'Blikvanger', 'Eyecatcher'];
    wrap.innerHTML = '';
    maten.forEach(function (maat, i) {
      var el = document.createElement('div');
      el.className = 'cfg-maat';
      el.setAttribute('data-afm', maat);
      el.innerHTML = '<div class="cfg-maat-impact">' + impacts[i] + '</div>'
                   + '<div class="cfg-maat-afm">' + maat + '</div>';
      wrap.appendChild(el);
    });
  }

  // Type tiles — skeleton tijdens laden
  function renderTypesSkeleton() {
    var wrap = document.getElementById('cfg-types');
    if (!wrap) return;
    wrap.innerHTML = '';
    for (var i = 0; i < 3; i++) {
      var sk = document.createElement('div');
      sk.className = 'cfg-type-tile cfg-type-skeleton';
      sk.innerHTML = '<div class="cfg-skeleton-img"></div>'
                   + '<div class="cfg-skeleton-line"></div>'
                   + '<div class="cfg-skeleton-line cfg-skeleton-line--sm"></div>';
      wrap.appendChild(sk);
    }
  }

  // Type tiles — met echte foto's vanuit variant.featured_image
  function renderTypes(typeImages) {
    var wrap = document.getElementById('cfg-types');
    if (!wrap) return;
    wrap.innerHTML = '';
    TYPES.forEach(function (t) {
      var imgUrl = typeImages[t.waarde] || null;
      var tile   = document.createElement('div');
      tile.className = 'cfg-type-tile';
      tile.setAttribute('data-type', t.waarde);
      if (imgUrl) tile.setAttribute('data-img', imgSrc(imgUrl, 400));
      tile.innerHTML =
        '<div class="cfg-type-img-wrap">'
        + (imgUrl
            ? '<img src="' + imgSrc(imgUrl, 200) + '" alt="' + escAttr(t.naam) + '" loading="lazy">'
            : '<div style="width:100%;height:100%;background:#e8e4de"></div>')
        + '</div>'
        + '<div class="cfg-type-naam">' + t.naam + '</div>'
        + (t.sub ? '<div class="cfg-type-sub">' + t.sub + '</div>' : '');
      wrap.appendChild(tile);
    });
    // Tiles zijn net gebouwd — update direct naar de al-gekozen kleur
    if (cfg.kleurCode && cfg.formaat && cfg.handle) {
      wrap.querySelectorAll('.cfg-type-tile[data-type]').forEach(function (tile) {
        var type = tile.getAttribute('data-type');
        var ts   = type === 'Inliggend' ? 'inliggend' : type === 'Opliggend' ? 'opliggend' : null;
        if (!ts) return;
        var imgEl = tile.querySelector('img');
        if (!imgEl) return;
        var fallback = tile.getAttribute('data-img') || '';
        imgEl.onerror = function () { imgEl.src = fallback; imgEl.onerror = null; };
        imgEl.src = getKleurImg(cfg.formaat, cfg.handle, ts, cfg.kleurCode);
      });
    }
    // Pre-selecteer type vanuit kleurverkenner landing page
    if (cfg.pendingType) {
      var pendTile = wrap.querySelector('.cfg-type-tile[data-type="' + cfg.pendingType + '"]');
      if (pendTile) cfgKiesType(pendTile);
      cfg.pendingType = null;
    }
  }

  function renderTypesFallback() { renderTypes({}); }

  // Kleur kiezen
  function cfgKiesKleur(code) {
    document.querySelectorAll('.cfg-swatch[data-code], .cfg-swatch--sm[data-code]').forEach(function (s) {
      s.classList.remove('actief');
    });
    document.querySelectorAll('[data-code="' + code + '"]').forEach(function (s) {
      s.classList.add('actief');
    });
    cfg.kleurCode = code;
    var naamEl    = document.getElementById('cfg-kleur-naam');
    var meldingEl = document.getElementById('cfg-maatwerk-melding');
    if (naamEl)    naamEl.textContent  = KLEUREN[code] ? KLEUREN[code].naam : '';
    if (meldingEl) meldingEl.style.display = (KLEUREN[code] && KLEUREN[code].gpoWaarde) ? '' : 'none';
    cfgUpdateImg();
    // Update type-tile afbeeldingen naar de gekozen kleur
    if (cfg.formaat && cfg.handle) {
      document.querySelectorAll('.cfg-type-tile[data-type]').forEach(function (tile) {
        var type = tile.getAttribute('data-type');
        var ts   = type === 'Inliggend' ? 'inliggend' : type === 'Opliggend' ? 'opliggend' : null;
        if (!ts) return;
        var imgEl = tile.querySelector('img');
        if (!imgEl) return;
        var fallback = tile.getAttribute('data-img') || '';
        var url = getKleurImg(cfg.formaat, cfg.handle, ts, code);
        imgEl.onerror = function () { imgEl.src = fallback; imgEl.onerror = null; };
        imgEl.src = url;
      });
    }
    cfgUpdateVariant();
  }

  // Afmeting kiezen
  function cfgKiesMaat(el) {
    document.querySelectorAll('.cfg-maat').forEach(function (t) { t.classList.remove('actief'); });
    el.classList.add('actief');
    cfg.maat = el.getAttribute('data-afm');
    cfgUpdateVariant();
  }

  // Type kiezen — toont kleur-specifieke afbeelding als kleur gekozen is,
  // anders de type-specifieke Shopify productfoto (via data-img op de tile).
  function cfgKiesType(el) {
    document.querySelectorAll('.cfg-type-tile').forEach(function (t) { t.classList.remove('actief'); });
    el.classList.add('actief');
    cfg.type = el.getAttribute('data-type');
    cfgUpdateImg(el.getAttribute('data-img') || null);
    cfgUpdateVariant();
  }

  // Variant + prijs bijwerken na elke selectieverandering
  function cfgUpdateVariant() {
    if (!cfg.productData || !cfg.kleurCode || !cfg.maat || !cfg.type) {
      cfgUpdatePrijs(null); return;
    }
    var v = vindVariant(cfg.productData, cfg.kleurCode, cfg.maat, cfg.type);
    cfg.variantId = v ? v.id   : null;
    cfg.prijs     = v ? v.price : null;
    cfgUpdatePrijs(v ? v.price : null);
  }

  function cfgUpdatePrijs(centen) {
    var klaar = !!(cfg.kleurCode && cfg.maat && cfg.type && centen);
    var btnEl  = document.getElementById('btn-incart');
    var prijs  = document.getElementById('cfg-prijs');
    var sub    = document.getElementById('cfg-prijs-sub');
    if (btnEl) btnEl.disabled = !klaar;
    if (prijs) prijs.textContent = centen ? formatPrijs(centen) : '\u2014';
    if (sub)   sub.textContent   = cfg.type === TYPES[2].waarde ? 'Set: inliggend + opliggend' : '';
  }

  // Toevoegen aan winkelmand via /cart/add.js
  function voegToe() {
    if (!cfg.variantId) return;
    var btn = document.getElementById('btn-incart');
    if (btn) {
      btn.disabled = true;
      btn.innerHTML = '<span class="cfg-btn-dots">'
        + '<span class="cfg-btn-dot"></span>'
        + '<span class="cfg-btn-dot"></span>'
        + '<span class="cfg-btn-dot"></span>'
        + '</span>';
    }

    var k = KLEUREN[cfg.kleurCode];
    var properties = {};
    if (k && k.gpoWaarde) properties['Maatwerk kleur'] = k.gpoWaarde;

    khTrack('keuzehulp_add_to_cart', {
      product: cfg.naam,
      kleur:   k ? k.naam : '',
      maat:    cfg.maat,
      type:    cfg.type === TYPES[2].waarde ? 'Twin' : cfg.type
    });

    var afgerond = false;
    function klaar(cb) {
      if (afgerond) return;
      afgerond = true;
      clearTimeout(timeoutId);
      cb();
    }
    var timeoutId = setTimeout(function() { klaar(cfgToonError); }, 10000);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: cfg.variantId, quantity: 1, properties: properties }]
      })
    })
    .then(function(r) {
      if (!r.ok) {
        return r.json().then(
          function(e) { throw e; },
          function() { throw new Error('HTTP ' + r.status); }
        );
      }
      return r.json();
    })
    .then(function() { klaar(cfgToonSuccess); })
    .catch(function() { klaar(cfgToonError); });
  }

  function cfgToonSuccess() {
    var k         = KLEUREN[cfg.kleurCode];
    var typeLabel = cfg.type === TYPES[2].waarde ? 'Twin' : cfg.type;
    var kleurNaam = k ? k.naam : '';
    var omschr    = cfg.naam + ' \u00b7 ' + kleurNaam + ' \u00b7 ' + cfg.maat + ' \u00b7 ' + typeLabel;

    khTrack('keuzehulp_besteld', {
      product: cfg.naam,
      kleur:   kleurNaam,
      maat:    cfg.maat,
      type:    typeLabel,
      waarde:  cfg.prijs ? cfg.prijs / 100 : 0,
      currency: 'EUR'
    });

    var scroll  = document.getElementById('cfg-scroll');
    var bottom  = document.getElementById('cfg-bottom');
    var success = document.getElementById('cfg-success');
    var omschrEl = document.getElementById('cfg-success-omschr');
    if (scroll)   scroll.style.display = 'none';
    if (bottom)   bottom.style.display = 'none';
    if (omschrEl) omschrEl.textContent = omschr;
    if (success)  success.classList.add('show');

    // Winkelmandje-teller bijwerken (werkt bij de meeste Shopify-thema's)
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function cfgToonError() {
    var btn = document.getElementById('btn-incart');
    if (btn) {
      btn.disabled = false;
      btn.innerHTML = 'Probeer opnieuw';
    }
  }

  function naarWinkelmand() {
    window.location.href = '/cart';
  }


  // ============================================================
  // OPEN / SLUITEN
  // ============================================================

  function open(trigger) {
    var overlay = document.getElementById('kh-overlay');
    if (!overlay) return;
    khTrack('keuzehulp_open', { trigger: trigger || 'overig' });
    tabVerbergen();
    resetState();
    // Zorg dat config panel altijd gesloten start
    var panel = document.getElementById('kh-config-panel');
    if (panel) { panel.classList.remove('kh-config-open'); panel.setAttribute('aria-hidden', 'true'); }
    var body = document.getElementById('kh-body');
    if (body) body.classList.remove('kh-body--vers');
    render();
    overlay.classList.add('kh-overlay--open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('kh-body-lock');
  }

  function close() {
    var overlay = document.getElementById('kh-overlay');
    var modal   = document.getElementById('kh-modal');
    if (!overlay) return;

    // Slide-out + fade-out animatie (280 ms) vóór het verbergen van de overlay
    var dur = 280;
    if (modal) {
      modal.style.animation   = 'kh-slide-out ' + dur + 'ms cubic-bezier(0.25,0.46,0.45,0.94) forwards';
      overlay.style.animation = 'kh-fade-out '  + dur + 'ms ease forwards';
    }
    setTimeout(function () {
      overlay.classList.remove('kh-overlay--open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('kh-body-lock');
      if (modal) { modal.style.animation = ''; }
      overlay.style.animation = '';
      tabHerstellen();
    }, dur);
  }


  // ============================================================
  // INIT — gedelegeerde event-handlers
  // ============================================================

  function init() {
    // Eén gedelegeerde click-handler voor de hele pagina.
    // Werkt ook als nieuwe triggers dynamisch in de DOM worden gezet.
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-kh-open]')) {
        e.preventDefault();
        var trigger = e.target.closest('.kh-banner') ? 'banner'
                    : e.target.closest('#kh-side-tab') ? 'sidetab'
                    : 'overig';
        open(trigger);
      }
      if (e.target.closest('#kh-sluiten'))         close();
      if (e.target.closest('#kh-opnieuw-header')) { resetState(); render(); }

      // Terug: sluit config panel als dat open is, anders stap terug
      if (e.target.closest('#kh-terug')) {
        var panel = document.getElementById('kh-config-panel');
        if (panel && panel.classList.contains('kh-config-open')) {
          sluitConfig();
        } else if (state.stap > 1) {
          state.stap--;
          render();
        }
      }

      // Klik op de overlay buiten de modal sluit de drawer
      var overlay = document.getElementById('kh-overlay');
      if (overlay && e.target === overlay) close();

      // Kinderkaart op resultaatpagina → GA4 event (navigatie loopt gewoon door)
      if (e.target.closest('.kh-kinder-kaart')) {
        khTrack('keuzehulp_kinder_click', { formaat: state.formaat });
      }

      // Swatch lightbox: openen via klik op .kh-swatch-item
      var swatchItem = e.target.closest('.kh-swatch-item[data-kleur-code]');
      if (swatchItem) openSwatchLightbox(swatchItem.dataset.kleurCode);
      // Swatch lightbox: sluiten via X-knop
      if (e.target.closest('#kh-lightbox-sluiten')) closeSwatchLightbox();

      // Muur-visualisatie: openen via klik op .kh-maat-info tile
      var maatTile = e.target.closest('.kh-maat-info[data-w]');
      if (maatTile) {
        openMaatPreview(
          parseInt(maatTile.dataset.w, 10),
          parseInt(maatTile.dataset.h, 10),
          maatTile.querySelector('.kh-maat-naam').textContent,
          maatTile.dataset.twin === 'true'
        );
      }
      // Muur-visualisatie: sluiten via X-knop
      if (e.target.closest('#kh-maat-lb-sluiten')) closeMaatPreview();

      // ── Config panel ──────────────────────────────────────────
      // "Samenstellen & bestellen" knop én klik op kaartfoto
      // Kan ook worden aangeroepen vanaf de landing page (buiten de drawer).
      var cfgBtn = e.target.closest('.kh-cfg-btn[data-handle]');
      if (cfgBtn) {
        if (cfgBtn.dataset.formaat) state.formaat = cfgBtn.dataset.formaat;
        // Pre-selecteer kleur + type vanuit kleurverkenner landing page
        if (cfgBtn.dataset.kleur) kaartKleurState[cfgBtn.dataset.handle] = cfgBtn.dataset.kleur;
        if (cfgBtn.dataset.typewaarde) cfg.pendingType = cfgBtn.dataset.typewaarde;
        var ov = document.getElementById('kh-overlay');
        if (ov && !ov.classList.contains('kh-overlay--open')) {
          khTrack('keuzehulp_open', { trigger: 'kleurverkenner' });
          ov.classList.add('kh-overlay--open');
          ov.setAttribute('aria-hidden', 'false');
          document.body.classList.add('kh-body-lock');
          state.directMode = true;
          var bd = document.getElementById('kh-body');
          if (bd) bd.innerHTML = '';
        }
        openConfig(cfgBtn.dataset.handle, cfgBtn.dataset.naam, cfgBtn.dataset.img);
      }

      // Kleurwissel op resultaatkaart
      var kaartSwatch = e.target.closest('.kh-kaart-swatch[data-design][data-code]');
      if (kaartSwatch) kaartWisselKleur(kaartSwatch.dataset.design, kaartSwatch.dataset.code);

      // Kleur swatch klik (aanbevolen of meer kleuren)
      var cfgSwatch = e.target.closest('.cfg-swatch[data-code], .cfg-swatch--sm[data-code]');
      if (cfgSwatch) cfgKiesKleur(cfgSwatch.dataset.code);

      // Meer kleuren toggle
      if (e.target.closest('#cfg-meer-btn')) toggleMeerKleuren();

      // Afmeting tile
      var cfgMaat = e.target.closest('.cfg-maat[data-afm]');
      if (cfgMaat) cfgKiesMaat(cfgMaat);

      // Type tile
      var cfgType = e.target.closest('.cfg-type-tile[data-type]');
      if (cfgType) cfgKiesType(cfgType);

      // In winkelmand knop
      if (e.target.closest('#btn-incart')) voegToe();

      // Naar winkelmand
      if (e.target.closest('#btn-naar-cart')) naarWinkelmand();

      // Verder winkelen
      if (e.target.closest('#btn-verder')) sluitConfig();
    });

    // ESC: sluit eerst de bovenste lightbox, dan pas de drawer
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (document.getElementById('kh-maat-lightbox')) {
          closeMaatPreview();
        } else if (document.getElementById('kh-swatch-lightbox')) {
          closeSwatchLightbox();
        } else {
          close();
        }
      }
    });

    // Side tab tonen op akoestische pagina's
    tabTonen();
  }

  // Wacht op DOMContentLoaded als de DOM nog niet klaar is
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
